import { ServiceTagData } from "../Interfaces/Interfaces";
import "./Tag.scss";

export const Tag = (props: { tag: ServiceTagData }) => (
  <div className={"tag"}>{props.tag.name}</div>
);
